import { render } from "./UserGame.vue?vue&type=template&id=646709ec"
import script from "./UserGame.vue?vue&type=script&lang=ts"
export * from "./UserGame.vue?vue&type=script&lang=ts"
script.render = render

export default script